<template>
  <div class="preliminary">
    <approval
      :departmentId="departmentId"
      :isBillType="isBillType"
    />
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import Approval from "@/components/approval.vue";
export default {
  components: {
    Approval
  },

  data() {
    return {
      departmentId: 0,
      isBillType: 2,
    }
  },

  created() {
    config()
  },

  methods: {
  }
}
</script>

<style lang='scss'>
.preliminary {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
